import React from 'react';
import {
  Box,
  Chip,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CircleIcon from '@mui/icons-material/Circle';

const MOCK_SPRINTS = [
  { name: 'Sprint 14 — Payments hardening', points: '18 / 26', daysLeft: 4 },
  { name: 'Sprint 15 — Portal branding', points: '6 / 20', daysLeft: 11 },
];

const MOCK_ARCH_LINKS = [
  { title: 'System context diagram', href: '#' },
  { title: 'Firebase topology', href: '#' },
  { title: 'Runbooks & on-call', href: '#' },
];

const MOCK_API_DOCS = [
  { title: 'REST — Tickets API', version: 'v1' },
  { title: 'Webhooks — Liveness events', version: 'beta' },
  { title: 'Internal — Cloud Functions', version: 'latest' },
];

export default function DeveloperDashboard({ welcomeName, onOpenMonitoring }) {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Developer workspace
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Welcome back, {welcomeName}. Engineering focus for this sprint cycle.
      </Typography>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Paper variant="outlined" sx={{ p: 2.5, height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <RocketLaunchIcon color="primary" />
              <Typography variant="h6">Active sprints</Typography>
            </Box>
            <List dense disablePadding>
              {MOCK_SPRINTS.map((sprint) => (
                <ListItem key={sprint.name} disableGutters sx={{ flexDirection: 'column', alignItems: 'flex-start', py: 1.5 }}>
                  <Typography variant="subtitle2">{sprint.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {sprint.points} pts · {sprint.daysLeft} days left
                  </Typography>
                  <Chip size="small" label="Placeholder" sx={{ mt: 0.5 }} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Paper variant="outlined" sx={{ p: 2.5, height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <AccountTreeIcon color="primary" />
              <Typography variant="h6">System architecture links</Typography>
            </Box>
            <List dense>
              {MOCK_ARCH_LINKS.map((item) => (
                <ListItem key={item.title} disableGutters>
                  <ListItemIcon sx={{ minWidth: 28 }}>
                    <CircleIcon sx={{ fontSize: 8 }} color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Link href={item.href} underline="hover" color="inherit">
                        {item.title}
                      </Link>
                    }
                  />
                </ListItem>
              ))}
            </List>
            {onOpenMonitoring && (
              <Typography variant="caption" color="text.secondary">
                Or open{' '}
                <Link component="button" variant="caption" onClick={onOpenMonitoring}>
                  Uptime Monitoring
                </Link>{' '}
                for live monitors.
              </Typography>
            )}
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Paper variant="outlined" sx={{ p: 2.5, height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <MenuBookIcon color="primary" />
              <Typography variant="h6">API docs</Typography>
            </Box>
            <List dense>
              {MOCK_API_DOCS.map((doc) => (
                <ListItem key={doc.title} disableGutters>
                  <ListItemText primary={doc.title} secondary={doc.version} />
                  <Chip size="small" label="Soon" variant="outlined" />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
